import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from "react-redux";
import useFacilityGroup from '../../../../hooks/useFacilityGroup';
import Form from './Form';

const SharedFacilitiesSetting = ({ entityID, entityType, value, setValue, parentValue, handleResetChange, handleInputSave }) => {
    const [toggle, setToggle] = useState((value?.length > 0 && value !== '[]') ? true : false);
    const { facilityGroupID, facilityGroupChildren } = useFacilityGroup(entityID);

    const entity = useSelector(state => state?.orgTree?.entities?.[entityID]);

    useEffect(() => {
        if (value?.length > 0 && value !== '[]') {
            setToggle(true);
        }
    }, [value]);

    const onToggle = async () => {
        setToggle(!toggle);
        setValue('sharedfacilities', []);
        await handleInputSave('sharedfacilities', '');
    }

    if (!facilityGroupID) {
        return null;
    }

    const handleFacilityChange = async (selected) => {
        const selectedIds = selected.map(option => option.id);
        setValue('sharedfacilities', selectedIds);
        await handleInputSave('sharedfacilities', `[${selectedIds.join(',')}]`);
    };

    const filteredGroupFacilities = facilityGroupChildren
        .filter(facility => facility.entityid !== entityID && facility.entityid !== entity?.parententityid)
        .map(facility => ({ id: facility.entityid, value: facility.name }));

    const selectedFacilities = filteredGroupFacilities.filter(f => value.includes(f.id));

    return (
        <Form
            handleFacilityChange={handleFacilityChange}
            toggle={toggle}
            onToggle={onToggle}
            entityID={entityID}
            entityType={entityType}
            value={value}
            parentValue={parentValue}
            handleResetChange={handleResetChange}
            selectedFacilities={selectedFacilities}
            filteredGroupFacilities={filteredGroupFacilities}
        />
    )
}

export default SharedFacilitiesSetting;